import { Component, EventEmitter, Optional, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-grok-image',
  templateUrl: './grok-image.component.html',
  styleUrls: ['./grok-image.component.scss']
})
export class GrokImageComponent {

  /** Clarichat model key used in ChatFireService switch-case */
  readonly modelId = 'grokimage';

  /** Underlying xAI model id for documentation/UX */
  readonly apiModelId = 'grok-2-image';

  /** Emit if the user wants to use this model (for non-MatDialog hosts) */
  @Output() selectModel = new EventEmitter<string>();

  /** Emit when closed (for non-MatDialog hosts) */
  @Output() closed = new EventEmitter<void>();

  constructor(@Optional() private dialogRef?: MatDialogRef<GrokImageComponent>) {}

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
    this.closed.emit();
  }

  useModel(): void {
    // If opened as a MatDialog, close with a payload; otherwise emit directly
    if (this.dialogRef) {
      this.dialogRef.close({ selectModel: this.modelId });
    }
    this.selectModel.emit(this.modelId);
  }
}
